<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-form v-model="formValid" lazy-validation @submit.prevent ref="form">
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Admin panel</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-img
              contain
              class="ma-4"
              :height="100"
              :src="require('../assets/img/logo.png')"
            />
            <v-text-field
              :prepend-icon="fa('user')"
              :rules="[formRules.required, formRules.email]"
              name="login"
              label="Email"
              type="text"
              v-model="email"
            />
            <v-text-field
              id="password"
              :prepend-icon="fa('key')"
              :append-icon="fa(showPassword ? 'eye' : 'eye-slash')"
              :rules="[formRules.required, formRules.min]"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              label="Password"
              v-model="password"
              @click:append="showPassword = !showPassword"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="login"
              :loading="loading"
              :disabled="!formValid"
              type="input"
              >Login</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import { eventHub } from "../config/constants";

export default {
  name: "Login",
  data: () => ({
    loading: false,
    formValid: false,
    showPassword: false,
    email: null,
    password: null
  }),
  methods: {
    async login() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        const user = (await this.$auth.signInWithEmailAndPassword(
          this.email,
          this.password
        )).user;
        const idTokenResult = await user.getIdTokenResult();
        if (idTokenResult.claims.admin || idTokenResult.claims.user) {
          eventHub.user = user;
          this.$router.replace(this.$route.query.nextUrl || "/");
        } else {
          throw new Error("Forbidden");
        }
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.loading = false;
    }
  }
};
</script>
